import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { isSupportObjectFit } from 'src/app/util';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { SECTION_DATA } from 'src/app/web-generator/index-section-generator/service/section-data';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { SwiperOptions } from 'swiper';
import { AbstractIndexBanner } from '../../abstract-index-banner';
import { map } from 'rxjs/operators';
import { BannerMeta } from 'src/app/web-generator/template-generator/entity/banner-meta';

@Component({
  selector: 'app-index-banner-02',
  templateUrl: './index.component.html',
  styleUrls: [
    '../../../index-subject/index-subject-04/index/index.component.scss',
    './index.component.scss'
  ]
})
export class IndexComponent extends AbstractIndexBanner {
  readonly isSupportObjectFit = isSupportObjectFit;
  limit = 8;
  defaultData = {};
  remoteDefaultData = [
    {
      id: 0,
      title: '雲林國際偶戲節，邀您來雲林看好戲',
      type: null,
      description: '雲林國際偶戲節，邀您來雲林看好戲',
      imageFile: {
        id: 0,
        name: 'act-01',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        url: '/assets/images/V007/tmp/act-01.webp'
      },
      link: '',
      dataProvider: '',
      video: '',
    },
    {
      id: 0,
      title: '雲林國際偶戲節，邀您來雲林看好戲',
      type: null,
      description: '雲林國際偶戲節，邀您來雲林看好戲',
      imageFile: {
        id: 0,
        name: 'act-01',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        url: '/assets/images/V007/tmp/act-01.webp'
      },
      link: '',
      dataProvider: '',
      video: '',
    }
  ];
  swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    lazy: true,
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    autoplay: {
      delay: 10000,
    },
    loop: true,
    breakpoints: {
      576: {
        slidesPerView: 2,
      }
    }
  };
  toHomePath: string;

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected templateService: TemplateService,
    protected translate: TranslateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, templateService, translate); 

    this.toHomePath = `/${translate.currentLang}`;
  }

  refreshRemoteData() {
    this.serverConfigService.getConfig$().pipe(
      map(siteInfo => {
        return siteInfo.banners;
      })
    ).subscribe(
      (bannerMeta: BannerMeta[]) => {
        this.remoteData = bannerMeta.filter(banner => banner.type === 0 && banner.imageFile);
      },
      (error) => this.remoteData = this.remoteDefaultData
    );
  }
  
}
